import 'jquery';
import '../utils/slick.js';

$(function () {
    const blockBusinessCards = $(".block-business__cards.mobile");
    blockBusinessCards.slick({
        prevArrow: '<div class="arrow-left"></div>',
        nextArrow: '<div class="arrow-right"></div>',
        autoplay: true,
        autoplaySpeed: 8000,
        dots: false,
        infinite: true,
        slidesToShow: 1,
        init: function(event, slick) {
            blockHeroLogos.find('.slick-slide').css('opacity', 0);
            blockHeroLogos.find('.slick-slide').animate({ opacity: 1 }, 500);
        }
    });
});